import React from "react";
import {navLinks} from "../utils/constants";
import {Link, NavLink} from "react-router-dom";
import profilePhoto from "../img/profile_photo.jpg";

function SidebarOne() {
    const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-blue-500 text-md m-2';
    const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 ' +
        'dark:hover:text-black hover:bg-light-gray m-2';

    return (
        <div className="sidebar">
            <div className="sidebar-content">
                <div className="sidebar-header">
                    <a href="/about" className="sidebar-header-wrap w-inline-block">
                        <div className="sidebar-header-avatar-wrap">
                            <img src={profilePhoto} loading="lazy" alt="" className="sidebar-header-avatar"/>
                            <div className="sidebar-header-avatar-outline"></div>
                        </div>
                        <div className="sidebar-header-info">
                            <div className="sidebar-header-name">Mufaro Gomera</div>
                            <div className="sidebar-header-title">
                                <div>Civil Engineer, Web & Mobile Developer</div>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="sidebar-navbar">
                    <div data-w-id="37c44af6-4b5a-46b9-ff50-27f15031981f" className="navbar-list">
                        {navLinks.map((item) => (
                            <div>
                                <div className="navbar-list-divider"></div>
                                <NavLink data-w-id="37c44af6-4b5a-46b9-ff50-27f150319828" to={`/${item.link}`}
                                      className={({ isActive }) => isActive ? "navbar-link w-inline-block w--current" : "navbar-link w-inline-block"}>
                                    <div className="w-layout-grid navbar-link-content">
                                        <div className="navbar-icon-wrap">
                                            <div className="navbar-inactive-icon w-embed">
                                                {item.urlInActive}
                                            </div>
                                        </div>
                                        <div>{item.title}</div>
                                    </div>
                                </NavLink>
                                <div className="navbar-list-divider"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="sidebar-bg-tablet"></div>
            <div className="sidebar-navbar-tablet">
                <a href="/about" className="sidebar-tablet-brand w-inline-block">
                    <div className="sidebar-tablet-avatar-wrap">
                        <img src={profilePhoto} loading="lazy" alt="" className="sidebar-header-avatar"/>
                        <div className="sidebar-header-avatar-outline"></div>
                    </div>
                    <div className="sidebar-tablet-avatar-info">
                        <div className="sidebar-tablet-avatar-name">Mufaro Gomera</div>
                        <div className="sidebar-tablet-avatar-title">
                            <div>Civil Engineer, Web & Mobile Developer</div>
                        </div>
                    </div>
                </a>
                <a href="#" className="sidebar-tablet-menu w-inline-block">
                    <div className="menu-burger w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5"/>
                        </svg>
                    </div>
                    <div className="menu-close w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default SidebarOne